import { Select, Spin } from 'antd'
import { useState, useEffect } from 'react'

InstanceSearcher = ({ onChange, placeholder, query, style, elId }) ->

  [options, setOptions] = useState([])
  [value, setValue] = useState(undefined)
  [loading, setLoading] = useState(false)
  [initting, setInitting] = useState(true)

  useEffect(->
    init = ->
      await fillResults('')
      setInitting(false)
    init()
    undefined
  , [])

  fillResults = (text) ->
    setLoading(true)
    results = await query(text)
    setOptions(results)
    setLoading(false)

  <Select
    filterOption={false}
    showSearch={true}
    loading={loading}
    notFoundContent={if loading then <Spin size="small" />}
    onSearch={fillResults}
    onChange={(key, label) ->
      await onChange(key)
      setValue(key)
    }
    id={elId}
    placeholder={placeholder}
    style={style}
    value={value}
  >
    {options.map((opt) ->
      <Select.Option key={opt.id()}>
        <span 
          style={{ 
            fontFamily: 'Material-Design-Iconic-Font', 
            marginRight: 5
          }}
        >
          { opt.className }
        </span>
        { opt.get('Thing_hasNameByLiteral_xsd') }
      </Select.Option>
    )}
  </Select>

export default InstanceSearcher
